import * as React from "react";
import { FC } from "react";
import { Product } from "~/apps/pos/models";
import { ProductGroupAccordion } from "./ProductGroupAccordion";
import ProductsTable from "./ProductsTable";

type Props = {
  title: string;
  productGroups: Product[][];
  canManage: boolean;
  isCategoryEnabled: boolean;
  onEdit: (row: Product) => void;
  onDelete: (row: Product) => void;
};

const ProductsSection: FC<Props> = ({ title, productGroups, canManage, isCategoryEnabled, onEdit, onDelete }) => {
  return (
    <div>
      <Title title={title} />
      {!productGroups.length ? (
        <div className="empty-state">
          <div className="empty-state__cont">{"No results found"}</div>
        </div>
      ) : (
        <>
          {productGroups.map((group, idx) => {
            return group[0]?.group?.id ? (
              <ProductGroupAccordion
                group={group}
                key={`${group[0].group.id}`}
                canManage={canManage}
                isCategoryEnabled={isCategoryEnabled}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ) : (
              <div key={idx} style={{ padding: "20px" }}>
                <ProductsTable
                  data={group}
                  canManage={canManage}
                  isCategoryEnabled={isCategoryEnabled}
                  onEdit={onEdit}
                  onDelete={onDelete}
                />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default ProductsSection;


const Title = ({ title }: { title: string }) => (
  <div
    style={{
      fontSize: "20px",
      fontWeight: 600,
      margin: "20px 0",
    }}
  >
    {title}
  </div>
);